import { isAxiosError } from '~/src/helpers/whoseError';
import { logout } from '~/src/store/actions/auth';

/**
 * @param {Function} dispatch
 * @param {Error} error
 * @param {Response} [response] express response
 * @return {boolean}
 */
export function catch401(dispatch, error, response = null) {
    if (!isAxiosError(error)) {
        return false;
    }

    if (error.response.status === 401) {
        dispatch(logout(response));
        return true;
    }

    return false;
}
